// extracted by mini-css-extract-plugin
export default {"columns":"Groups_columns__wuetH"};